import { render, staticRenderFns } from "./BlockTotals.vue?vue&type=template&id=0eae4ac1&scoped=true&lang=pug&"
import script from "./BlockTotals.vue?vue&type=script&lang=ts&"
export * from "./BlockTotals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eae4ac1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VDivider,VSheet})
